module.exports = __webpack_public_path__ + "img/sy-nav-act.613e9a49.png";